import { render, staticRenderFns } from "./ProfileBasicDetails.vue?vue&type=template&id=8b5d9258&scoped=true&"
import script from "./ProfileBasicDetails.vue?vue&type=script&lang=js&"
export * from "./ProfileBasicDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProfileBasicDetails.vue?vue&type=style&index=0&id=8b5d9258&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5d9258",
  null
  
)

export default component.exports